import {Map} from 'immutable';

export default {
  setDisplayConditions(state, displayConditions) {
    state.displayConditions = displayConditions;
  },
  pushNewDisplayCondition(state, displayCondition) {
    displayCondition.new = true;
    const displayConditions = state.displayConditions;
    displayConditions.forEach(element => {
      element.new = false;
    });
    displayConditions.unshift(displayCondition);
    state.displayConditions = displayConditions;
  },
  setCurrentPage(state, currentPage) {
    state.currentPage = currentPage;
  },
  setPageCount(state, pageCount) {
    state.pageCount = pageCount;
  },
  setFields(state, fields) {
    state.fields = fields;
  },
  setValues(state, {field, values}) {
    const filteredValues = values.filter(v => v !== null);
    state.values = state.values.set(field, filteredValues);
  },
  resetValues(state) {
    state.values = Map();
  },
  setEditConditions(state, editConditions) {
    state.editConditions = editConditions;
  },
  setConditionToEdit(state, condition) {
    state.conditionToEdit = condition;
  },
  setConditionToDelete(state, condition) {
    state.conditionToDelete = condition;
  }
};
